import React from 'react';
//import { ScrollMenu,  VisibilityContext } from 'react-horizontal-scrolling-menu';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import useDrag from './UseDrag';
//import { value Card } from './Card';

// NOTE: embrace power of CSS flexbox!
// import './arrowsOnBottomOrTop.css';
import './hideScrollbar.css';
//import './firstItemMargin.css';
//import { value Shimmer } from '../Shimmer';
//import { value GlobalContext } from '../../contexts/HomeContext';
import { ICategorias } from '../../Types';
import { GlobalContext } from '../../contexts/HomeContext';
import { Shimmer } from '../Shimmer';
import { Card } from './Card';
//import { value ICategorias } from '../../Interfaces';
import { LeftArrow, RightArrow } from './Arrows';
// prettier-ignore
type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

// const elemPrefix = 'test';
// const getId = (index: number) => `${elemPrefix}${index}`;

// const getItems = () =>
//   Array(20)
//     .fill(0)
//     .map((_, ind) => ({ id: getId(ind) }));

function MenuCategorias() {
  const { dadosApp } = React.useContext(GlobalContext);
  //const [items] = React.useState(dadosApp.Cardapio.Categorias); //getItems
  const [selected, setSelected] = React.useState<string>('');

  const { dragStart, dragStop, dragMove } = useDrag();
  // prettier-ignore
  const handleDrag = ({ scrollContainer }: scrollVisibilityApiType) => (ev: React.MouseEvent) => dragMove(ev, (posDiff) => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollLeft += posDiff;
    }
  });

  // NOTE: for select item
  const handleItemClick = (item: ICategorias) => () => scrollToTargetAdjusted(item);

  const scrollToTargetAdjusted = (item: ICategorias) => {
    const categoria =
      item.categoria_ecommerce === '' ? item.subgrupo.toUpperCase() : item.categoria_ecommerce.toUpperCase();

    setSelected(categoria);
    let element = document.getElementById(categoria);

    let top = 150;
    let headerOffset = window.scrollY - top;
    let elementPosition = element?.getBoundingClientRect().top;
    if (elementPosition) {
      let offsetPosition = elementPosition + headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const handleScroll = React.useCallback(() => {
    let scrollDistance = document.body.scrollTop || document.documentElement.scrollTop;
    scrollDistance = scrollDistance - 250;
    document.querySelectorAll('.page-section').forEach(function (i) {
      var el = i as HTMLElement;
      if (el.offsetTop <= scrollDistance) {
        setSelected(i.id.trim());
      }
    });
  }, []);

  React.useEffect(() => {
    dadosApp.Cardapio.Categorias.slice(0, 1).map((i: ICategorias) => {
      if (i.categoria_ecommerce === '') setSelected(i.subgrupo.toUpperCase());
      setSelected(i.categoria_ecommerce.toUpperCase());
    });

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [dadosApp.Cardapio.Categorias, handleScroll]);

  return (
    <>
      <div id="categorias" className="categorias stickyMenu categorias_padZero">
        <div className="container categorias_padZero">
          <div className="scrollMenu">
            {dadosApp.Cardapio.Categorias.length === 0 && <Shimmer type="Categorias" />}

            {dadosApp.Cardapio.Categorias.length > 0 && (
              <ScrollMenu
                LeftArrow={LeftArrow}
                RightArrow={RightArrow}
                onWheel={onWheel}
                options={{
                  ratio: 0.9,
                  rootMargin: '5px',
                  threshold: [0.01, 0.05, 0.5, 0.75, 0.95, 1],
                  throttle: 0, // NOTE: for center items
                }}
                onMouseDown={() => dragStart}
                onMouseUp={() => dragStop}
                // onMouseUp={({ getItemById, scrollToItem, visibleItems }: scrollVisibilityApiType) =>
                //   () => {
                //     // NOTE: for center items
                //     dragStop();
                //     const { center } = getItemsPos(visibleItems);
                //     scrollToItem(getItemById(center), 'smooth', 'center');
                //   }}
                onMouseMove={handleDrag}
              >
                {dadosApp.Cardapio.Categorias.map((item: any) => (
                  <Card
                    title={item.categoria_ecommerce === '' ? item.subgrupo : item.categoria_ecommerce}
                    //title={item.id}
                    itemId={item.id} // NOTE: itemId is required for track items
                    key={item.id}
                    onClick={handleItemClick(item)}
                    selected={item.categoria_ecommerce === selected || item.subgrupo === selected}
                  />
                ))}
              </ScrollMenu>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default MenuCategorias;

function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

  if (isThouchpad) {
    ev.stopPropagation();
    return;
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext();
  } else if (ev.deltaY > 0) {
    apiObj.scrollPrev();
  }
}

//ReactDOM.render(<App />, document.getElementById('root'));
